import script from "./domp.vue?vue&type=script&setup=true&lang=js"
export * from "./domp.vue?vue&type=script&setup=true&lang=js"

import "./domp.vue?vue&type=style&index=0&id=a214d1ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a214d1ec"]])

export default __exports__